import { render, staticRenderFns } from "./HeadrPage.vue?vue&type=template&id=04178023&scoped=true"
import script from "./HeadrPage.vue?vue&type=script&lang=js"
export * from "./HeadrPage.vue?vue&type=script&lang=js"
import style0 from "./HeadrPage.vue?vue&type=style&index=0&id=04178023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04178023",
  null
  
)

export default component.exports